import React from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { PlansDetails } from "../FetchAPI";
import LegalBradcrumeSection from "../Community/LegalBradcrumeSection";
import { useAuth } from "../../Store/AuthContext";
import "./PlanDetailsCss.css";
import DOMPurify from "dompurify";
import PlanSubmitForm from "./PlanSubmitForm";

export default function PlanDetails() {
  const { RendomTokenfetch, userRoll } = useAuth();
  let { planslug } = useParams();
  //   const [webSetting] = WebsiteSetting(RendomTokenfetch);
  // const [webSetting] = WebsiteSetting();

  const [PlanDetails] = PlansDetails(RendomTokenfetch, planslug, userRoll);
  // console.log(PlanDetails);
  // const service_tag = PlanDetails.feature_tag;
  // const serviceTag = service_tag.split(",");
  const serviceTag = PlanDetails?.feature_tag
    ? PlanDetails.feature_tag.split(",")
    : [];
  return (
    <>
      <Helmet>
        <title>{PlanDetails.meta_title}</title>
        <meta name="description" content={PlanDetails.meta_description} />
        <meta name="keywords" content={PlanDetails.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <LegalBradcrumeSection
        Pagename={PlanDetails.plan_title}
        page1={[
          { name: "Services", pagelink: "services" },
          { name: PlanDetails.catname },
          { name: PlanDetails.plan_title },
        ]}
      />
      <section className="shop-single">
        <div className="auto-container">
          <div className="product-details">
            <div className="basic-details">
              <div className="row clearfix">
                <div className="image-column col-md-6 col-sm-12">
                  <figure className="image">
                    <div className="lightbox-image">
                      <img
                        src={
                          PlanDetails.image
                            ? PlanDetails.image
                            : "images/index-12/news/4.png"
                        }
                        alt=""
                      />
                      {/* <span className="icon flaticon-magnifying-glass"></span> */}
                    </div>
                  </figure>
                </div>
                <div className="info-column col-md-6 col-sm-12">
                  <div className="inner-column">
                    <h4 className="product-name">{PlanDetails.plan_title}</h4>
                    <div className="text">{PlanDetails.short_description}</div>
                    <div className="item-price">
                      ₹{PlanDetails.selling_price}
                      <del> ₹{PlanDetails.price}</del>
                    </div>
                    <ul className="product-meta">
                      <li>
                        <span className="plasdetDECS">Category:</span>{" "}
                        {PlanDetails.catname}
                      </li>
                      <li>
                        <span className="plasdetDECS">Service:</span>{" "}
                        {PlanDetails.service}
                      </li>
                      {PlanDetails.subservice && (
                        <li>
                          <span className="plasdetDECS">Sub-Service:</span>{" "}
                          {PlanDetails.subservice}
                        </li>
                      )}

                      <li>
                        <span className="plasdetDECS">Features:</span>{" "}
                        <ul
                          style={{ listStyleType: "disc" }}
                          className="plnasfeatureBox p-0"
                        >
                          {serviceTag &&
                            serviceTag.map((valuetag, index) => (
                              <li key={index} className="plnasfeatureLi">
                                <i
                                  className="fa fa-hand-o-right"
                                  aria-hidden="true"
                                ></i>
                                {valuetag}
                              </li>
                            ))}
                        </ul>
                      </li>
                    </ul>
                    <div className="other-options">
                      <div className="btn-box">
                        <NavLink
                          to={`/checkout/${PlanDetails.slug}`}
                          className="theme-btn btn-style-three submitbtn "
                        >
                          Book Now
                        </NavLink>
                      </div>  
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="product-info-tabs planDetaislTabs">
              <div className="container mt-3">
                <div className="row">
                  <div className="col-lg-8 col-md-12 col-sm-12 mb-3">
                    <ul className="nav nav-tabs" role="tablist">
                      <li className="nav-item">
                        <a
                          className="PlansTabsLink nav-link active"
                          data-bs-toggle="tab"
                          href="#description"
                        >
                          Description
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="PlansTabsLink nav-link"
                          data-bs-toggle="tab"
                          href="#review"
                        >
                          Review (2)
                        </a>
                      </li>
                    </ul>

                    <div className="tab-content PlansTabsContent">
                      <div
                        id="description"
                        className="container tab-pane active "
                      >
                        <div className="content PlansContent row">
                          <div className="col-lg-12 col-md-12 col-sm-12">
                            <h4>Details</h4>
                            <p
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(
                                  PlanDetails.description
                                ),
                              }}
                            ></p>
                          </div>
                        </div>
                      </div>
                      <div id="review" className="container tab-pane fade">
                        <div className="content PlansContent">
                          <div className="comments-area">
                            <div className="comment-box">
                              <h4>Comment</h4>
                              <div className="comment">
                                <div className="user-thumb">
                                  <img
                                    src="../images/resource/candidate-2.png"
                                    alt=""
                                  />
                                </div>
                                <div className="comment-info">
                                  <div className="user-name">Oscar Cafeo</div>
                                  <div className="title">Beautiful courses</div>
                                  <div className="rating">
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                  </div>
                                </div>
                                <div className="text">
                                  Far much that one rank beheld bluebird after
                                  outside ignobly allegedly more when oh
                                  arrogantly vehement tantaneously eel valiantly
                                  petted this along across highhandedly much.
                                </div>
                              </div>
                            </div>

                            <div className="comment-box">
                              <div className="comment">
                                <div className="user-thumb">
                                  <img
                                    src="../images/resource/candidate-1.png"
                                    alt=""
                                  />
                                </div>
                                <div className="comment-info">
                                  <div className="user-name">Alex Morgan</div>
                                  <div className="title">Beautiful courses</div>
                                  <div className="rating">
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                    <i className="fa fa-star"></i>
                                  </div>
                                </div>
                                <div className="text">
                                  Far much that one rank beheld bluebird after
                                  outside ignobly allegedly more when oh
                                  arrogantly vehement tantaneously eel valiantly
                                  petted this along across highhandedly much.
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="comment-form default-form">
                            <h4>Leave your thought here</h4>
                            <form>
                              <div className="row clearfix">
                                <div className="rating-box col-lg-12 col-md-12 col-sm-12 form-group">
                                  <div className="rating">
                                    <Link to="#">
                                      <span className="fa fa-star"></span>
                                    </Link>
                                    <Link to="#">
                                      <span className="fa fa-star"></span>
                                    </Link>
                                    <Link to="#">
                                      <span className="fa fa-star"></span>
                                    </Link>
                                    <Link to="#">
                                      <span className="fa fa-star"></span>
                                    </Link>
                                    <Link to="#">
                                      <span className="fa fa-star"></span>
                                    </Link>
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 form-group">
                                  <label>Your Name</label>
                                  <input
                                    type="text"
                                    name="username"
                                    placeholder="Name"
                                    required
                                  />
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 form-group">
                                  <label>Your Email</label>
                                  <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    required
                                  />
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                  <label>Your Review</label>
                                  <textarea
                                    name="message"
                                    placeholder="Write Review"
                                  ></textarea>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                  <button
                                    className="theme-btn btn-style-three"
                                    type="submit"
                                    name="submit-form"
                                  >
                                    Send Review
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12">
                    <PlanSubmitForm />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
